import React from 'react'
import { GeneralLedger, Particular, SubLedger } from '../../../../helpers/models/Models';
import { useFormik } from 'formik';
import { putDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess } from '../../../../constants/Toast';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import DefaultSelectInputBox from '../../../../constants/DefaultSelectBox';
import { DebitCreditOptions, YesNoOptions } from '../../../../constants/Options';
import DialogBox from '../../../../constants/DialogBox';

interface ParticularEditViewProps {
    dialogOpen: boolean;
    currentItem: Particular | null;
    setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleFormSuccess: () => void;
}
const ParticularEditView: React.FC<ParticularEditViewProps> = ({ dialogOpen, handleFormSuccess, currentItem, setDialogOpen }) => {
    const initialValues = {
        particular_id: currentItem?.particular_id || "",
        particular_name: currentItem?.particular_name || "",
        particular_name_nep: currentItem?.particular_name_nep || "",
        assets_dep_pers: currentItem?.assets_dep_pers || "0",
        status: currentItem?.status === 1 ? "1" : "2",
        sub_gl_related_id: currentItem?.sub_gl_related_id === 0 ? "2" : "1",
        is_debit: currentItem?.is_debit === 1 ? "1" : "2",
        particu_for_assets: currentItem?.particu_for_assets,
    };

    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: authorValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("particular_name", values.particular_name);
            formData.append("particular_name_nep", values.particular_name_nep);
            formData.append("assets_dep_pers", values.assets_dep_pers?.toString()??"0");
            formData.append("status", values.status?.toString() === "1" ? "1" : "0");
            formData.append("is_debit", values.is_debit?.toString() === "1" ? "1" : "0");
            formData.append("particu_for_assets", values.particu_for_assets?.toString() ?? "");
            try {
                await putDataToTheServer(AppURL.AccountURL + "account/particular/ledger/update/view/" + currentItem?.particular_id, formData).then((res) => {
                    if (res?.status === 200) {
                        ToastSuccess({ message: res?.message });
                        setDialogOpen(false)
                        handleFormSuccess();
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    
    return (
        <DialogBox open={dialogOpen} headerName='Particular Edit' close={() => setDialogOpen(false)}>
            <form onSubmit={handleSubmit}>
                <Grid container columnSpacing={0.5} rowSpacing={0.5}>
                    <Grid item lg={4} md={4} xs={12} xl={4} sm={12}>
                        <InputTextBox
                            type='text'
                            label='Particular Name'
                            name='particular_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            error={errors.particular_name}
                            disabled={false}
                            value={values.particular_name}
                            placeholder='Enter Particular Name'
                            required={true}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12} xl={4} sm={12}>
                        <NepaliInputBox
                            label="Particular Name(Nepali)"
                            name='particular_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'particular_name_nep' })}
                            value={values.particular_name_nep}
                            error={errors.particular_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.particular_name_nep}
                            placeholder='Enter Particular Name(Nepali)'
                            required={true} />
                    </Grid>

                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Assets Depression Percent'
                            name='assets_dep_pers'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            error={errors.assets_dep_pers}
                            disabled={false}
                            value={values.assets_dep_pers}
                            placeholder='Enter Assets Depression Percent'
                            required={true}
                        />
                    </Grid>
                   
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Debit/Credit"
                            options={DebitCreditOptions}
                            name='is_debit'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select Debit/Credit'
                            value={values.is_debit}
                            touched={touched.is_debit}
                        />
                    </Grid>
                    {/* <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Report Details Show"
                            options={YesNoOptions}
                            name='show_det_mode'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select status'
                            value={values.show_det_mode}
                            touched={touched.show_det_mode}
                        />
                    </Grid> */}
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='status'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select GL Status'
                            value={values.status}
                            touched={touched.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={20}>
                            <Button btn_type='update' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default ParticularEditView